import React from 'react';

interface Props {
  height: number;
}

const LoadingState: React.FC<Props> = ({ height }) => (
  <div style={{ height: `${height}px`, width: '100%' }} />
);

export default LoadingState;
